import React, { useState, useEffect, useCallback } from "react";
import {
  Grid,
  Card,
  Button,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Switch,
  Backdrop,
  CircularProgress,
  Alert,
  Snackbar,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import apiRequest from "../../apiRequest";
import { endPoints } from "../../apis";

function OrderStatuses() {
  const [orderStatuses, setOrderStatuses] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [accessToken, setAccessToken] = useState('');
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [currentId, setCurrentId] = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

  const [newData, setNewData] = useState({
    name: "",
    description: "",
    status: "active",
  });

  const initialState = {
    name: "",
    description: "",
    status: "active",
  };

  // Fetch category with pagination
  const fetchOrderStatuses = useCallback(
    async (page) => {
      setLoading(true);
      try {
        const params = { page, total: totalItems };
        const headers = {
          "x-access-token": accessToken,
        };
        const response = await apiRequest.get(endPoints.GET_ORDER_STATUSES,
          params,
          headers,
        );

        if (response.success) {
          const { items, pagination } = response.data;
          setOrderStatuses(items);
          setTotalPages(pagination.total_pages);
          setCurrentPage(pagination.current_page);
          setTotalItems(pagination.totalItems);
        }
      } catch (error) {
        console.error("Error fetching order statuses:", error);
        setError("Failed to fetch order statuses. Please try again.");
      } finally {
        setLoading(false);
      }
    },
    [accessToken, totalItems]
  );

  // Fetch category when currentPage changes
  useEffect(() => {
    setAccessToken(localStorage.getItem("access_token"));
    fetchOrderStatuses(currentPage);
  }, [currentPage]);

  // Handle modal open/close
  const handleOpenModal = () => {
    setOpenModal(true);
    setNewData(initialState);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
    setNewData(initialState);
    setIsEditing(false);
  };

  // Handle form input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewData({ ...newData, [name]: value });
  };

  // Handle form submission
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);
  //   setError(null);
  //   setSuccess(null);

  //   try {
  //     const formData = new FormData();

  //     // Append text fields
  //     formData.append('name', newData.name_en);
  //     formData.append('description', newData.name_fr);
    
  //     // Determine the endpoint and method based on whether it's an edit or add operation
  //     const endPoint = isEditing
  //       ? `${endPoints.UPDATE_CATEGORY}/${currentId}`
  //       : `${endPoints.ADD_CATEGORY}`;
  //     const requestMethod = isEditing ? apiRequest.put : apiRequest.post;

  //     // Send the request
  //     const response = await requestMethod(endPoint, formData, {
  //       headers: {
  //         'Content-Type': 'multipart/form-data',
  //         'x-access-token': accessToken,
  //       },
  //     });

  //     // Handle the response
  //     if (response.success) {
  //       setSuccess(isEditing ? "Category updated successfully." : "Category added successfully.");
  //       getCategories(currentPage); // Refresh the Category list
  //       handleCloseModal(); // Close the modal
  //     } else {
  //       setError(response.message || 'Failed to add/update Category.');
  //     }
  //   } catch (error) {
  //     console.error('Error:', error);
  //     setError('An error occurred while processing your request.');
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // Handle edit servict type
  // const handleEdit = (category) => {
  //   handleOpenModal();
  //   setIsEditing(true);
  //   setCategoryData({
  //     name_en: category.name_en || "",
  //     name_fr: category.name_fr || "",
  //     description_en: category.description_en || "",
  //     description_fr: category.description_fr || "",
  //     image: category.image || null,
  //     image_preview: category.image ? `${apiRequest.BASE_URL}/${category.image}` : null,
  //     status: category.status || "active",
  //   });

  //   setCurrentId(category.id);
  // };

  // Handle delete Category
  // const handleDelete = async (id) => {
  //   try {
  //     setLoading(true);
  //     setError(null);
  //     setSuccess(null);

  //     // Send the DELETE request to the API
  //     const response = await apiRequest.delete(
  //       `${endPoints.DELETE_CATEGORY}/${id}`,
  //       {
  //         headers: {
  //           'x-access-token': accessToken,
  //         },
  //       }
  //     );

  //     // Handle the response
  //     if (response.success) {
  //       setSuccess("Category deleted successfully.");

  //       // Update the local state to remove the deleted Category
  //       setCategories((prev) => prev.filter((categoryData) => categoryData.id !== id));
  //     } else {
  //       setError(response.message || "Failed to delete the Category.");
  //     }
  //   } catch (error) {
  //     console.error("Error deleting Category:", error);
  //     setError("An error occurred while deleting the Category.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // Handle page change
  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage); // Update the current page
    }
  };

  // const handleStatusToggle = async (id, currentStatus) => {
  //   try {
  //     setLoading(true);
  //     setError(null);
  //     setSuccess(null);

  //     const newStatus = currentStatus === "active" ? "inactive" : "active";
  //     const payload = {
  //       status: newStatus,
  //     };

  //     const headers = {
  //       'Content-Type': 'application/json',
  //       'x-access-token': accessToken,
  //     };

  //     // Send the PUT request to update the Category status
  //     const response = await apiRequest.put(
  //       `${endPoints.STATUS_CATEGORY}/${id}`,
  //       payload,
  //       { headers }
  //     );

  //     // Handle the response
  //     if (response.success) {
  //       setSuccess("Service Type status updated successfully.");

  //       // Update the local state immediately
  //       setCategories((prev) =>
  //         prev.map((categoryData) =>
  //           categoryData.id === id ? { ...categoryData, status: newStatus } : categoryData
  //         )
  //       );
  //     } else {
  //       setError(response.message || 'Failed to update service type status.');
  //     }
  //   } catch (error) {
  //     console.error('Error updating service type status:', error);
  //     setError('An error occurred while updating the service type status.');
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Order Statuses
                </MDTypography>
              </MDBox>
              <MDBox pt={1} px={1}>
                <MDBox
                  pt={1}
                  px={1}
                  display="flex"
                  justifyContent="flex-end"
                  alignItems="center"
                  gap={2}
                >
                  <TextField
                    label="Search"
                    variant="outlined"
                    margin="normal"
                    placeholder="Search by title or description"
                    style={{ width: "300px" }}
                  />
                  {/* <Button
                    variant="contained"
                    color="primary"
                    onClick={handleOpenModal}
                    style={{
                      whiteSpace: "nowrap",
                      color: "white",
                    }}
                  >
                    Add Order Statuses
                  </Button> */}
                </MDBox>
                <TableContainer component={Paper} style={{ marginTop: "1px" }}>
                  <Table>
                    <TableBody>
                      <TableRow>
                        <TableCell style={{ fontWeight: "bold" }}>Name</TableCell>
                        <TableCell style={{ fontWeight: "bold" }}>Description</TableCell>
                        <TableCell style={{ fontWeight: "bold" }}>Status</TableCell>
                        {/* <TableCell style={{ fontWeight: "bold" }}>Actions</TableCell> */}
                      </TableRow>
                      {orderStatuses.map((orderStatus) => (
                        <TableRow key={orderStatus.id}>
                          <TableCell>{orderStatus.name}</TableCell>
                          <TableCell>{orderStatus.description}</TableCell>
                          <TableCell>
                            <Switch
                              checked={orderStatus.status === "active"} // Assuming "active" is the active status
                              // onChange={() => handleStatusToggle(orderStatus.id, orderStatus.status)}
                              color="primary"
                            />
                          </TableCell>
                          {/* <TableCell>
                            <Button
                              onClick={() => handleEdit(category)}
                              color="primary"
                              size="small"
                            >
                              Edit
                            </Button>
                            <Button
                              onClick={() => {
                                setCurrentId(category.id); // Set the service type ID to delete
                                setDeleteDialogOpen(true); // Open the confirmation dialog
                              }}
                              color="error"
                              size="small"
                              style={{ marginLeft: "8px" }}
                            >
                              Delete
                            </Button>
                          </TableCell> */}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>

                {/* Pagination Controls */}
                <MDBox mt={2} display="flex" justifyContent="center" alignItems="center">
                  <Button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    Previous
                  </Button>
                  <MDTypography mx={2}>
                    Page {currentPage} of {totalPages} {/* Display current page and total pages */}
                  </MDTypography>
                  <Button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    Next
                  </Button>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />

  

      {/* Loading Backdrop */}
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      {/* Error/Success Snackbar */}
      <Snackbar
        open={!!error || !!success}
        autoHideDuration={3000}
        onClose={() => {
          setError(null);
          setSuccess(null);
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }} // Positioning the Snackbar
      >
        <Alert
          onClose={() => {
            setError(null);
            setSuccess(null);
          }}
          severity={error ? "error" : "success"}
          sx={{ width: '100%' }}
        >
          {error || success}
        </Alert>
      </Snackbar>
    </DashboardLayout>
  );
}

export default OrderStatuses;